import type { i18n as I18nInstance } from 'i18next';

const SUPPORTED = new Set(['en', 'es', 'pt', 'fr', 'it', 'hi', 'gr', 'jp']);

/**
 * Maps ACV i18n / AiStudio language codes to aiRecording locale folders (public/locales/*).
 */
export function normalizeLanguageForAiRecording(raw: unknown): string | null {
  if (raw == null) return null;
  const s = String(raw).trim().toLowerCase();
  if (!s) return null;
  const base = s.split(/[-_]/)[0];
  if (base === 'ja') return 'jp';
  if (base === 'de') return 'en';
  if (SUPPORTED.has(base)) return base;
  return null;
}

export function applyLanguageFromAcv(
  i18n: I18nInstance,
  raw: unknown,
): void {
  const code = normalizeLanguageForAiRecording(raw);
  if (!code) return;
  try {
    localStorage.setItem('language', code);
    void i18n.changeLanguage(code);
  } catch {
    /* ignore */
  }
}
